import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => RadioComponent),
    },
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class RadioComponent implements OnInit, ControlValueAccessor {
  @Input() name: string = '';
  @Input() value: string = '';
  @Input() label: string = '';
  @Input() disabled: boolean = false;
  @Input() type: 'default' | 'mat' = 'default';
  @Output() onChangeClick = new EventEmitter();
  @Output() onChangeSave = new EventEmitter();
  @Output() onChangeCancel = new EventEmitter();
  @Output() onValueChange = new EventEmitter();

  @Input() input: string = '';
  copyInput: string = '';

  ngOnInit(): void {}

  onChange = (data: any) => {};
  onTouch = (_: any) => {};

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  writeValue(value: string) {
    this.input = value;
    this.onChange(value);
  }

  /**
   *Func triggered on input change
   */
  onchange(event: any) {
    this.input = event;
    this.onChange(event);
    this.onValueChange.emit(event);
  }
}
